import React from 'react';

interface HtmlDisplayProps {
  file: string;
}

const HtmlDisplay: React.FC<HtmlDisplayProps> = ({ file }) => {
  return (
    <iframe
      src={file}
      title="HTML Content"
      width="100%"
      height="500px"
      style={{ border: 'none' }}
      sandbox="allow-scripts allow-popups allow-forms allow-top-navigation allow-popups-to-escape-sandbox"
    />
  );
};

export default HtmlDisplay;
